export default "__VITE_ASSET__DHF9p7_b__"